import React from "react";

const SimpleFast = () => {
  const steps = [
    {
      num: "01",
      icon: (
        <img
          src="/icons/upload_photo.png"
          alt="Upload"
          className="w-10 h-10 object-contain"
        />
      ),
      title: "Upload a Patient Photo",
      desc: "Take a quick photo with any smartphone or DSLR during the consultation. No special lighting or equipment needed.",
    },
    {
      num: "02",
      icon: (
        <img
          src="/icons/generate_sim.png"
          alt="Generate AI Simulation"
          className="w-10 h-10 object-contain"
        />
      ),
      title: "AI Generates the Smile Simulation",
      desc: "SmileReveal's dental AI analyzes facial proportions, skin tone, and dental structure to create a photorealistic smile preview in seconds.",
    },
    {
      num: "03",
      icon: (
        <img
          src="/icons/show_patient.png"
          alt="Show Patient Outcome"
          className="w-10 h-10 object-contain"
        />
      ),
      title: "Show the Patient Their Future Smile",
      desc: "Present the AI simulation chairside, on mobile, or via email. Patients see their implant, veneer, or whitening results before committing.",
    },
  ];

  return (
    <section className="py-24 px-3 sm:px-4 lg:px-6 max-w-7xl mx-auto">
      <div className="text-center mb-16 px-4">
        <h2 className="text-[36px] md:text-[42px] font-bold text-slate-900 mb-4 tracking-tight leading-tight">
          How AI Smile Simulation Works — 3 Simple Steps
        </h2>
        <p className="text-slate-500 text-[17px] font-medium max-w-2xl mx-auto">
          SmileReveal™ was designed for busy dental practices — no technical
          skills, special equipment, or training required
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
        {steps.map((step, index) => (
          <div
            key={index}
            className="bg-white rounded-[32px] p-8 sm:p-10 border border-[#f1f5f9] relative overflow-hidden flex flex-col min-h-[320px] xl:h-[340px] group transition-all duration-300 shadow-md hover:shadow-[0_8px_32px_rgba(0,0,0,0.06)] hover:-translate-y-1 hover:border-blue-100"
          >
            {/* Background Number */}
            <div className="absolute top-2 right-4 text-[130px] sm:text-[150px] font-semibold text-[#f0f5ff] leading-none pointer-events-none select-none tracking-tighter z-0 group-hover:scale-[1.03] transition-transform duration-500 origin-top-right group-hover:text-[#e8f0fe]">
              {step.num}
            </div>

            {/* Icon */}
            <div
              className="w-[84px] h-[84px] rounded-[24px] flex items-center justify-center shadow-lg shadow-[#1a73e8]/25 relative z-10 transition-transform duration-300 group-hover:scale-105"
              style={{
                background:
                  "radial-gradient(circle at center, #3b82f6 0%, #0066ff 100%)",
              }}
            >
              {step.icon}
            </div>

            {/* Content at Bottom */}
            <div className="mt-auto relative z-10">
              <h3 className="text-[20px] md:text-[22px] xl:text-[20px] font-bold text-slate-900 mb-2 tracking-tight leading-[1.2]">
                {step.title}
              </h3>
              <p className="text-[#64748b] text-[15px] font-medium leading-relaxed">
                {step.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SimpleFast;
